import superagentPromise from "superagent-promise";
import _superagent from "superagent";
//import commonStore from "../home/login/stores/commonStore";
import { ENV } from "../Infrastructure/EnvironmentConfig";

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = ENV.API_ROOT;

const handleErrors = (err) => {
  if (err.status === 401) {
    window.location.href = "/login";
  } else if (err.status === 423) {
    window.location.href = "/licence-expired";
  }
  throw err;
};

const responseBody = (res) => {
  console.log(res);
  return res.body;
};

const tokenPlugin = (req) => {
  let token = window.sessionStorage.getItem("qrjwt");
  if (token) {
    req.set("authorization", `Bearer ${token}`);
  }
};

const client = {
  del: (url) =>
    superagent
      .del(`${API_ROOT}${url}`)
      .withCredentials()
      .use(tokenPlugin)
      .catch(handleErrors)
      .then(responseBody),
  get: (url) => {
    return superagent
      .get(`${API_ROOT}${url}`)
      .withCredentials()
      .use(tokenPlugin)
      .catch(handleErrors)
      .then(responseBody);
  },
  getqs: (url, body) => {
    return superagent
      .get(`${API_ROOT}${url}`)
      .query(body)
      .withCredentials()
      .use(tokenPlugin)
      .catch(handleErrors)
      .then(responseBody);
  },

  getFile: (url, body) => {
    return superagent
      .get(`${API_ROOT}${url}`)
      .query(body)
      .responseType("blob")
      .withCredentials()
      .use(tokenPlugin)
      .catch(handleErrors)
      .then(responseBody);
  },
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .withCredentials()
      .catch(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .withCredentials()
      .use(tokenPlugin)
      .catch(handleErrors)
      .then(responseBody),
};

export { client, API_ROOT };

